import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, Box } from "@mui/material";
import { useEffect } from "react";
// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Backdrop, CircularProgress } from "@mui/material";
import ScrollToTop from "./components/scrollToTop";
import HomePage from "./pages/HomeScreen/HomePage";
import AboutPage from "./pages/AboutScreen/AboutPage";
import PricingPage from "./pages/PricingScreen/PricingPage";
import ProductTourPage from "./pages/ProductTourPage";
import ContactPage from "./pages/ContactPage";
import ComponentsPage from "./pages/ComponentsPage";
import FeaturesScreen from "./pages/FeaturesScreen/FeaturesScreen";
import TaskScreen from "./pages/TaskManagementScreen/TaskScreen";
import CommunicationScreen from "./pages/CommunicationRequestScreen/CommunicationScreen";
import FinancialScreen from "./pages/FinancialFeaturesScreen/FinancialScreen";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Privacy from "./pages/Privacy/Privacy";
import Terms from "./pages/Terms/Terms";
import Cookies from "./pages/Cookies/CookiesPolicy";
import AccessibilityScreen from "./pages/Accessibility/AccessibilityScreen";
import SecuritySection from "./pages/SecuritySection/SecurityScreen";
import MobileApp from "./pages/MobileApp/MobileApp";
import ViewAllIndustries from "./pages/AllIndustries/ViewAllIndustries";
import AccountExecutiveScreen from "./pages/AccountExecutiveScreen/AccountExecutiveScreen";
import { useState } from "react";
import { SocialLinksProvider } from "./components/fetchGetAppUrl";

// Create a custom theme with our color palette
const theme = createTheme({
  palette: {
    primary: {
      main: "#006EC2",
      text: "#5E5C5C",
    },
    tertiary: {
      main: "#003149", // Tertiary color
    },
    text: {
      primary: "#363333",

      secondary: "#868282", // Quaternary text color
    },
  },
  typography: {
    fontFamily: "Nunito, sans-serif",
    h1: {
      fontFamily: "Volkhov, serif",
      fontSize: "52px",
      fontWeight: 400,
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "58px",
      fontWeight: 600,
      lineHeight: 1.1,
    },
    h3: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "52px",
      fontWeight: 400,
      lineHeight: 1.1,
    },
    h4: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "68px",
      fontWeight: 700,
      lineHeight: 1.1,
    },
    body1: {
      fontFamily: "Nunito, sans-serif",
      fontSize: "28px",
      fontWeight: 500,
      lineHeight: 1.7,
    },
  },
});

function App() {
  // const [languageLoading, setLanguageLoading] = useState(false);

  return (
    <Router>
      <ScrollToTop />
      <SocialLinksProvider>

      <ThemeProvider theme={theme}>
        {/* <Backdrop
          open={languageLoading}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >

          <Header
          //  setLanguageLoading={setLanguageLoading} 
          />

          <Box component="main" sx={{ flexGrow: 1, py: 0, pb: 0 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/accessibility" element={<AccessibilityScreen />} />
              <Route path="/security" element={<SecuritySection />} />

              <Route path="/product-tour" element={<ProductTourPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/components" element={<ComponentsPage />} />
              <Route path="/time-tracking" element={<FeaturesScreen />} />
              <Route path="/task-management" element={<TaskScreen />} />
              <Route path="/communication" element={<CommunicationScreen />} />
              <Route path="/financial" element={<FinancialScreen />} />
              <Route path="/account-executive" element={<AccountExecutiveScreen />} />
              <Route path="/mobile-app" element={<MobileApp />} />
              <Route path="view-all-industries" element={<ViewAllIndustries />} />
            </Routes>
          </Box>

          {/* </Box> */}
        </Box>
        <Footer />
      </ThemeProvider>
          </SocialLinksProvider>
    </Router>
  );
}

export default App;
